import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { FormHelperText } from '@mui/material';
import { useController } from 'react-hook-form';

import dayjs from 'dayjs';
import updateLocale from 'dayjs/plugin/updateLocale';

import 'dayjs/locale/pt-br';
import 'dayjs/locale/es';

dayjs.extend(updateLocale);
dayjs.updateLocale('pt-br', {
  weekdaysMin: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
});

export default function ControlledDatePicker({
  name,
  control,
  format = 'DD/MM/YYYY',
  label,
  datePickerProps = {},
  helperText = '',
  locale = 'es',
  translateError = () => '',
}) {
  const { field, fieldState } = useController({ name, control });

  const defaultSlotProps = {
    textField: {
      fullWidth: true,
      error: !!fieldState.error,
      label,
      InputLabelProps: {
        shrink: true,
      },
      size: 'small',
    },
    field: { clearable: true },
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale={locale}>
      <DatePicker
        {...datePickerProps}
        localeText={{ calendarWeekNumberHeaderLabel: locale }}
        value={field.value}
        onChange={(newValue) => field.onChange(newValue)}
        slotProps={{
          ...defaultSlotProps,
          ...datePickerProps.slotProps,
        }}
        format={format}
      />
      {!!fieldState.error && (
        <FormHelperText error>
          {translateError(fieldState.error) || helperText}
        </FormHelperText>
      )}
    </LocalizationProvider>
  );
}
